import { ToolsContentContainer } from './style';
import { ToolsProps } from './types';

export function ToolsContent({ children, expanded, size }: Readonly<ToolsProps>) {
	return (
		<ToolsContentContainer expanded={expanded} size={size}>
			{children}
		</ToolsContentContainer>
	);
}
